import React from 'react';
import i18n from 'i18next';

import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import GridViewIcon from '@mui/icons-material/GridView';

import { ViewToggle } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import { useScreenSize } from '@/exceed';

import styles from '../styles/videoBrowseHeader.module.scss';

export default function videoBrowseHeader({
  onButtonGroupChanged,
  view,
}) {

  const screenSize = useScreenSize();

  const shouldDisplayToggle = 
    screenSize === 'xlarge' || 
    screenSize === 'large' ||
    screenSize === 'medium';

  const getButtonProps = (value) => ({
      key: value,
      onClick: () => onButtonGroupChanged(value),
      tooltip: {
        aria: { content: 'labelledby' },
        content: i18n.t(`aria-video-${value}`),
      },
    });

  const buttons = [
    {
      ...getButtonProps('tile'),
      icon: <GridViewIcon />,
    },
    {
      ...getButtonProps('list'),
      icon: <FormatListBulletedIcon />,
    },
  ];

  return (
    <div className={styles.header}>
      <Typo className={`${styles.title} ${styles.link}`} element="h4" variant="h4" modifier="bold">
        {i18n.t('browse')}
      </Typo>
      {shouldDisplayToggle && (
        <ViewToggle
          buttons={buttons}
          selectedValue={view}
        />
      )}
    </div>
  );
}
